import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import * as moment from 'moment';

import { CheckMochilaService } from '../../services/check-mochila.service';

@Component({
  selector: 'app-checkmochilaprint',
  templateUrl: './checkmochilaprint.component.html',
  styleUrls: ['./checkmochilaprint.component.css']
})
export class CheckmochilaprintComponent implements OnInit {
  public checklist = {
    'cliente': {
      'cliente_nome': ''
    },
    'unidade': {
      'unidade_nome': ''
    },
    'profissional': {
      'profissional_nome': ''
    },
    'veiculo': {
      'veiculo_placa': '',
      'veiculo_numero': ''
    },
    'mochila': {
      'mochila_nome': ''
    },    
    'check_mochila_data': '',
    'check_ambulancia_turno': '',
    'check_ambulancia_combustivel': '',
    'produtos': ''
  };

  constructor(
    private route: ActivatedRoute,
    private checkMochilaSvc: CheckMochilaService) { }

  ngOnInit() {

    let html;

    this.route.params.subscribe( params => {
			if (params.id) {
				this.checkMochilaSvc.getCheckMochila(params.id).then((data: any) => {
          data.check_mochila_data = moment(data.check_mochila_data, 'YYYY-MM-DD').format('DD/MM/YYYY');
          this.checklist = data;

          console.log("this.checklist = " , this.checklist);

          let html = "<h3>Checklist Mochila</h3>"

          let check_ambulancia_turno;
          if(this.checklist.check_ambulancia_turno == "D"){
            check_ambulancia_turno = "Diurno";
          }else{
            check_ambulancia_turno = "Noturno";
          }

        html += "   <!-- TURNO -->"
        html += "   <div>"
        html += "     <div class='panel-heading border-bottom'>"
        html += "       <h4>Turno</h4>"
        html += "     </div>"
        html += "     <div class='panel-body'>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-4'>"
        html += "           <div>"
        html += "             <label>Data turno: "+ this.checklist.check_mochila_data + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "         <div class='col-xs-4 col-xs-offset-4'>"
        html += "           <div>"
        html += "             <label>Periodo: "+ check_ambulancia_turno +"</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"
        html += "     </div>"
        html += "   </div>"
        html += "   <!-- TURNO END -->"
        html += "   <!-- LOCALIZACAO -->"
        html += "   <div>"
        html += "     <div class='panel-heading border-bottom'>"
        html += "       <h4>Localização</h4>"
        html += "     </div>"
        html += "     <div class='panel-body'>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-12'>"
        html += "           <div>"
        html += "             <label>Central: "+ this.checklist.cliente.cliente_nome + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-12'>"
        html += "           <div>"
        html += "             <label>Unidade/base: "+ this.checklist.unidade.unidade_nome + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-8'>"
        html += "           <div>"
        html += "             <label>Profissional: "+ this.checklist.profissional.profissional_nome + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"
        html += "     </div>"
        html += "   </div>"
        html += "   <!-- ------------------------------- -->"
        html += "   <!-- VEICULO -->"
        html += "   <div>"
        html += "     <div class='panel-heading border-bottom'>"
        html += "       <h4>Veículo</h4>"
        html += "     </div>"
        html += "     <div class='panel-body'>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-4'>"
        html += "           <div>"
        html += "             <label>Veículo: "+ this.checklist.veiculo.veiculo_placa + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-4'>"
        html += "           <div>"
        html += "             <label>Nome: "+ this.checklist.veiculo.veiculo_numero + "</label>"
        html += "           </div>"
        html += "         </div>"
        html += "       </div>"        
        html += "       <div class='row'>"
        html += "         <div class='col-xs-4'>"
        html += "           <label>Nível combustível:</label>"
        html += "         </div>"
        html += "         <div class='col-xs-1'>"
        html += "           <label> " + this.formatDataCombustivel(this.checklist.check_ambulancia_combustivel) + "</label>"
        html += "         </div>"
        html += "       </div>"
        html += "     </div>"
        html += "   </div>"
        html += "   <div>"
        html += "     <div class='panel-heading border-bottom'>"
        html += "       <h4>Mochila - " + this.checklist.mochila.mochila_nome + " </h4>"
        html += "     </div>"
        html += "     <div class='panel-body'>"
        html += "       <div class='row'>"
        html += "         <div class='col-xs-12'>"

        if(this.checklist.produtos.length != 0){

          html += "           <table>"
          html += "             <thead>"
          html += "               <tr>"
          html += "                 <th>Nome</th>"
          html += "                 <th>Quantidade</th>"
          html += "                 <th>Conforme</th>"
          html += "                 <th>Observação</th>"
          html += "               </tr>"
          html += "             </thead> "   
          html += "             <tbody>"     
          
            for(let produto of this.checklist.produtos) {
              html += "<tr>"
              html += "  <td style='width:150px'>" + produto['produto_nome'] + "</td>"
              html += "  <td style='width:150px'>" + produto['check_mochila_produto_quantidade'] + "</td>"
              html += "  <td style='width:150px'>" + this.formatDataSimNao(produto['check_mochila_produto_presenca']) + "</td>"
              html += "  <td style='width:150px'>" + this.formatNull(produto['check_mochila_produto_obs']) + "</td>"
              html += "</tr>"
            }
          

          html += "             </tbody>"
          html += "           </table>"

      }

        html += "         </div>"
        html += "       </div>"
        html += "     </div>"


          document.getElementById("sidebar").style.display = "none";
          document.getElementById('imprimir_checklist').innerHTML = html;
          window.print();
          document.getElementById("sidebar").style.display = "block";



				});
			}
		});
  }

  formatNull(obj){

    if(obj == null){
      obj = "";
    }

    return obj;
  }


  formatDataSimNao(data){
    switch(data){
      case 'S':
        return 'Sim';
      case 'N':
        return 'Não';
      default:
        return ''; 
    }
  }

  formatDataCombustivel(data){
    switch(data){
      case 'CH':
        return 'Cheio';
      case '34':
        return '3/4';
      case '12':
        return '1/2';
      case '14':
        return '1/4';
      case 'ND':
        return '0';
      default:
        return '';
    }
  }

}
